import {SMALL} from './BreakPoints.js'

// Meridian v6 spacing token names
export const SPACING_SMALL = "300";   // 8px
export const SPACING_MEDIUM = "400";  // 16px
export const SPACING_LARGE = "500";   // 32px

/*
    Responsive props to hold all the props relevant for device info and layout
    Immediate extension with spacing for Desktop and mobile
*/
export const responsiveProps = {

    isMobile: {
        default: false,
        [SMALL]: true
    },
    headerFont: {
        default: "h300",
        [SMALL]: "h100"
    },
    spacingInset_shorthand2: {
        default: `${SPACING_SMALL} ${SPACING_LARGE}`,
        [SMALL]: SPACING_SMALL,
    },
    spacingInset_shorthand3: {
        default: SPACING_LARGE,
        [SMALL]: SPACING_SMALL,
    },
}


// WEBPACK FOOTER //
// ./src/components/common/constant/ResponsiveProps.js